var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emp-forma"},[_vm._t("traka"),(_vm.poruka)?_c('div',{staticClass:"forma-poruka",attrs:{"role":"alert"}},[_c('b',[_vm._v("Spremanje nije uspjelo.")]),_vm._v(" "+_vm._s(_vm.poruka)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }